export const VITRIN_META = {
  vitrin: {
    title: 'Vitrin - Onedio',
    description: "En iyi ve en güncel içerikler Onedio'da. Sen de Onedio'nun önerdiği ürünleri incelemeyi ve keşfetmeyi unutma!",
  },
  elektronik: {
    title: 'Elektronik Ürün Tavsiyeleri, İncelemeleri ve İpuçları  - Onedio',
    description:
      "Elektronik ve teknoloji tutkunuysan aradığın her şey Onedio'da. Elektronik ürün incelemeleri, ürünlere dair tüm ipuçları ve eğlenceli içerikler için hemen tıkla!",
  },
  giyim: {
    title: 'Giyim ve Kombin Önerileri - Moda - Onedio',
    description:
      "Giyim ve kombin önerileri Onedio'da. En trend kıyafetleri, son zamanların moda akımlarını ve ünlülerin stil incelemelerini keşfetmek için tıkla!",
  },
  kozmetik: {
    title: 'Kozmetik - Makyaj ve Cilt Bakımı Ürünleri Tavsiyeleri  - Onedio',
    description:
      "Kozmetik ürünlerine dair aradığın tüm ipuçları Onedio'da. Makyaj, cilt bakımı ve saç bakımı ürünleri hakkında öneriler için hemen tıkla!",
  },
  'ev-yasam': {
    title: 'Ev Yaşam: Dekorasyon, Mutfak, Bahçe ve Daha Fazlası - Onedio',
    description:
      "Ev ve yaşam hakkında ihtiyacın olan tüm tüyolar Onedio'da. Ev düzenleme, temizlik, mutfak ve bahçe fikirleri için hemen tıkla!",
  },
  hediye: {
    title: 'Hediye Önerileri -  Anneye, Arkadaşa, Sevgiliye Hediye -  Onedio',
    description:
      'Hediye önerileri ve hediye fikirlerine ihtiyacın varsa Onedio her zaman yanında. Anneye, babaya, sevgiliye ve arkadaşa hediye tavsiyeleri için hemen tıkla!',
  },
};
